<script setup>
import Card from "lib/srv/components/Card";

const props = defineProps(["srvs", "ad", "cat", "pcatId", "catId", "catName", "ccy"]);

const ad = props.cat.splash.ads[props.ad];
const _srvs = props.srvs.slice(0, 3);

document.title = ad.keyword;
</script>

<template>
	<div class="page-marketplace-splash">
		<div class="header grid">
			<h1>{{ ad.keyword }}</h1>
			<img :src="`/media/marketplace/${pcatId}/${catId}/splash.jpg`" :alt="ad.keyword">
			<div class="intro">{{ ad.intro }}</div>
			<div class="feedback">
				<i class="fa-solid fa-quote-left vui-left"></i>
				<span>{{ cat.splash.feedback }}</span>
				<div class="rating">
					<i class="fa-solid fa-star"></i>
					<i class="fa-solid fa-star"></i>
					<i class="fa-solid fa-star"></i>
					<i class="fa-solid fa-star"></i>
					<i class="fa-solid fa-star"></i>
				</div>
			</div>
		</div>
		<div class="promo">
			<h2 class="featured">{{ ad.featured }}</h2>
			<div class="cta">Secure Your Spot - Book Now!</div>
			<UiScrollX class="carousel snap">
				<Card v-for="srv in _srvs" :key="srv.srv_id" :ccy="ccy" :srv="srv"/>
			</UiScrollX>
			<a class="vui-btn" :href="`category/${pcatId}/${catId}`">{{ $gettext("Find more in %1", catName) }}</a>
		</div>
		<div class="footer grid col-gap-36 row-gap-16">
			<div>
				<h2>{{ ad.benefitHead }}</h2>
				<div>{{ ad.benefitIntro }}</div>
				<ul>
					<li v-for="benefit in cat.splash.benefits">{{ benefit }}</li>
				</ul>
			</div>
			<div>
				<h2>{{ ad.whyHead }}</h2>
				<div>{{ ad.whyIntro }}</div>
				<ul>
					<li v-for="why in cat.splash.why">{{ why }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
